// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2EpMP","alert":"SettungsInbox_alert__2WShU"};